"use client";

import Link from "next/link";
import Image from "next/image";
import { trackEvent } from "@/components/GoogleAnalytics";

const IMAGE_CDN =
  process.env.NEXT_PUBLIC_IMAGE_CDN_URL || "";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 pt-16 pb-28 md:pb-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* Company Information - 4 columns */}
          <div className="lg:col-span-4">
            <div className="mb-4">
              <Image
                src={`${IMAGE_CDN}/assets/img/nimbalkar-maratha-vadhu-var-suchak-logo-white.svg`}
                alt="Nimbalkar Vadhu Var Suchak Logo"
                width={139}
                height={64}
                className="footer-logo h-16 w-auto"
              />
            </div>
            <p className="text-sm leading-relaxed text-white/60">
            NimbalkarVadhuVar.com is the most trusted Maratha matrimony service for the well educated Maratha grooms and brides. Maratha well educated Vadhu Var can register FREE to search for educated Maratha groom and brides verified profiles. You can view the list of educated Maratha profiles on just one click.
            </p>
          </div>

          {/* Information Links - 2 columns */}
          <div className="lg:col-span-2">
            <h2 className="mb-4 text-lg font-semibold text-white">
              Information
            </h2>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/about"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  href="https://marathivadhuvarsuchak.com/how-it-works"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  href="https://marathivadhuvarsuchak.com/blog"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  Blog &amp; Articles
                </Link>
              </li>
              <li>
                <Link
                  href="https://marathivadhuvarsuchak.com/membership"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  Membership
                </Link>
              </li>
              <li>
                <Link
                  href="https://marathivadhuvarsuchak.com/contact"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Privacy and Help Links - 2 columns */}
          <div className="lg:col-span-2">
            <h2 className="mb-4 text-lg font-semibold text-white">
              Privacy &amp; Help
            </h2>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/privacy-policy"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms-and-conditions"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link
                  href="https://marathivadhuvarsuchak.com/refund-policy"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  href="https://marathivadhuvarsuchak.com/help-guide"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  Help Guide
                </Link>
              </li>
              <li>
                <Link
                  href="https://marathivadhuvarsuchak.com/faq"
                  className="text-sm text-white/60 transition-colors hover:text-primary-400"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media and App Downloads - 4 columns */}
          <div className="lg:col-span-4">
            <h2 className="mb-4 text-lg font-semibold text-white">
              Connect With Us
            </h2>

            {/* Social Media Icons */}
            <div className="mb-8 flex space-x-6">
              <Link
                href="https://www.facebook.com/MarathiVadhuVarSuchak"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 transition-colors hover:text-primary-400"
                aria-label="Follow us on Facebook"
              >
                <svg
                  className="h-7 w-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </Link>
              <Link
                href="https://www.pinterest.com/marathivadhuvarsuchak/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 transition-colors hover:text-primary-400"
                aria-label="Follow us on Pinterest"
              >
                <svg
                  className="h-7 w-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z" />
                </svg>
              </Link>
              <Link
                href="https://www.instagram.com/marathivadhuvarsuchak"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 transition-colors hover:text-primary-400"
                aria-label="Follow us on Instagram"
              >
                <svg
                  className="h-7 w-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </Link>
              <Link
                href="https://x.com/MarathiVadhuVar"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 transition-colors hover:text-primary-400"
                aria-label="Follow us on X (formerly Twitter)"
              >
                <svg
                  className="h-7 w-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </Link>
              <Link
                href="https://www.youtube.com/@MarathiVadhuVarSuchak"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 transition-colors hover:text-primary-400"
                aria-label="Subscribe to our YouTube channel"
              >
                <svg
                  className="h-7 w-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </Link>
              <Link
                href="https://www.linkedin.com/in/Marathi-Vadhu-Var-Suchak"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 transition-colors hover:text-primary-400"
                aria-label="Connect with us on LinkedIn"
              >
                <svg
                  className="h-7 w-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </Link>
            </div>

            {/* App Download Buttons */}
            <div className="space-y-3">
              <h3 className="mb-2 text-sm font-medium text-white/60">
                Download Our App
              </h3>
              <div className="flex space-x-3">
                <Link
                  href="https://apps.apple.com/us/app/marathi-vadhu-var-suchak/id6755544958"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                  onClick={() =>
                    trackEvent("app_download_click", {
                      location: "footer",
                      platform: "ios",
                    })
                  }
                >
                  <Image
                    src={`${IMAGE_CDN}/assets/img/mvvs-app-store-button.png`}
                    alt="Download on App Store"
                    width={160}
                    height={45}
                    className="footer-app-btn h-12 w-auto rounded-lg transition-opacity hover:opacity-80"
                    unoptimized
                  />
                </Link>
                <Link
                  href="https://play.google.com/store/apps/details?id=com.mvvs.matrimony.mvvs_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                  onClick={() =>
                    trackEvent("app_download_click", {
                      location: "footer",
                      platform: "android",
                    })
                  }
                >
                  <Image
                    src={`${IMAGE_CDN}/assets/img/mvvs-google-play-icon.png`}
                    alt="Get it on Google Play"
                    width={160}
                    height={45}
                    className="footer-app-btn h-12 w-auto rounded-lg transition-opacity hover:opacity-80"
                    unoptimized
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 border-t border-gray-800 pt-8 text-center">
          <p className="mb-4 text-sm text-gray-400">
          This website is owned and operated by Marathi Vadhu Var Suchak. <br />
            This website is strictly for Marathi community matrimonial purposes
            only and not a dating website.
          </p>
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Marathi Vadhu Var Suchak - All Rights Reserved
            Reserved
          </p>
        </div>
      </div>
    </footer>
  );
}

